import React, { Component } from "react";
import Modal from "react-modal";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import moment from "jalali-moment/jalali-moment";
import "../../assets/css/eop_visit.css";
import { Progress } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import standingPerson from "../../assets/images/bg_002.png";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class Eop_Visit_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partners: [],
      id: "",
      eop_number: "",
      start_at: "",
      finish_at: "",
      subject: "",
      description: "",
      hospital_id: "",
      steps: [],
      complete_percent: "",
      mehvar: "",
      mehvar_icon: "",
      referrer_person: null,
      responsible_person: "",
      modalPartnerNum: 0,
      MonitorModalActions: false,
      modalActionsNum: 0,
      MonitorModal: false,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount = () => {
    this.setUpEopData();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getData = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v2/get_indicator_interval_averages?indicator_id=${this.listId}`,
          null,
          true
        )
      )
      .then((response) => {
        const data = response.data.intervals[this.intervalIndex].eop;
        data &&
          this.setState({
            description: data.description,
            eop_number: data.eop_number,
            finish_at: data.finish_at,
            start_at: data.start_at,
            steps: data.steps,
            subject: data.subject,
            partners: data.partners === null ? [] : data.partners,
          });
      });
  };

  setUpEopData = () => {
    const data = this.props.eopData;
    data &&
      this.setState({
        id: data.id,
        eop_number: data.eop_number,
        eop_certificate: data.eop_certificate,
        start_at: data.start_at,
        finish_at: data.finish_at,
        subject: data.subject,
        description: data.description,
        referrer_person: data.referrer_person,
        responsible_person: data.responsible_person,
        priority_status: data.priority_status,
        partners: data.partners === null ? [] : data.partners,
        hospital_id: data.hospital_id,
        complete_percent: data.complete_percent,
        has_eop_step: data.has_eop_step,
        status: data.status,
        kartabl_certificate: data.kartabl_certificate,
        committee_id: data.committee_id,
        year: data.year,
        mehvar: data.mehvar,
        mehvar_icon: data.mehvar_icon,
        mehvar_object: { name: data.mehvar, id: 1 },
        steps: data.steps,
      });
  };

  handleCloseMasoleanjam = () => {
    this.setState({ MonitorModal: false });
  };

  handleActions = (n) => {
    return this.setState({ MonitorModalActions: true, modalActionsNum: n });
  };

  handleCloseActions = () => {
    this.setState({ MonitorModalActions: false });
  };

  getNameById = (targetId, withPost = false, onlyPost = false, obj = false) => {
    const user = this.globalStorage.users.filter(
      (user) => user.id === targetId
    )[0];

    if (obj) return user;
    if (withPost) return `${user.fn} ${user.ln}${" (" + user.post + ")"}`;
    if (onlyPost) return user.post;
    return `${user.fn} ${user.ln}`;
  };

  render() {
    const {
      eop_number,
      start_at,
      finish_at,
      subject,
      description,
      steps,
      modalPartnerNum,
      MonitorModalActions,
      modalActionsNum,
      MonitorModal,
    } = this.state;
    return (
      <Container className="eop-visit__container u-background-white">
        <Container className="left-part">
          <List className="eop-visit__list">
            <Banner2 />
            {steps &&
              steps.length &&
              Array.from({ length: steps.length }).map((_, i) => (
                <ListItem2
                  i={i}
                  key={i + 1}
                  steps={steps}
                  onActions={() => this.handleActions(i)}
                  onMasoleanjam={() =>
                    this.setState({ MonitorModal: true, modalPartnerNum: i })
                  }
                />
              ))}
          </List>
          <div
            className="w-100 mx-auto d-flex"
            onClick={this.props.onRequestClose}
          >
            <button
              style={{ width: "200px", cursor: "pointer" }}
              className=" btn btn-primary rounded-pill py-3 u-fn-14 mx-auto mt-3"
            >
              بازگشت
            </button>
          </div>
        </Container>
        <Container className="right-part">
          <Card className="right-part__card u-background-blue">
            <div
              className="rounded-pill mt-3 border border-white w-100 position-relative"
              style={{ minHeight: "45px" }}
            >
              <TransparentInput
                className="u-caret-white text-white u-fn-14 "
                placeholder="موضوع"
                value={subject}
                onChange={() => ""}
              />
            </div>
            <div
              className="bg-white d-flex justify-content-between mt-3 w-100 flex-row-reverse"
              style={{ borderRadius: "50px", minHeight: "45px" }}
            >
              <div
                className="u-fn-14  text-primary d-flex justify-content-center align-items-center font-weight-bold"
                style={{ width: "50%" }}
              >
                <p className=" m-0">{eop_number}</p>
              </div>
              <div
                className="u-fn-14  text-primary d-flex justify-content-center align-items-center font-weight-bold"
                style={{ width: "50%" }}
              >
                <p className=" m-0">شمـاره</p>
              </div>
            </div>
            <div className="d-flex justify-content-between w-100 mt-3 flex-row-reverse">
              <div
                style={{ width: "47%", minHeight: "45px" }}
                className="u-fn-12 rounded-pill bg-white d-flex justify-content-center align-items-center text-primary font-weight-bold"
              >
                <p className="m-0">
                  <span>تاریخ پایان </span>
                  <span>{formatDate(finish_at)}</span>
                </p>
              </div>
              <div
                style={{ width: "47%", minHeight: "45px" }}
                className="u-fn-12 rounded-pill bg-white d-flex justify-content-center align-items-center text-primary font-weight-bold"
              >
                <p className="m-0">
                  <span>تاریخ شروع </span>
                  <span>{formatDate(start_at)}</span>
                </p>
              </div>
            </div>
            <div
              style={{
                height: "41%",
                borderRadius: "0.9375rem",
              }}
              className="bg-white mt-3 py-1 px-3"
            >
              <Textarea
                className="u-fn-13"
                placeholder="توضیحات"
                value={description}
                onChange={() => ""}
              />
            </div>
            <div
              className="bg-white mt-3 d-flex justify-content-center flex-wrap py-1 px-2 text-center
            "
              style={{
                height: "190px",
                borderRadius: "0.9375rem",
              }}
            >
              <p className="progress-circle__title u-fn-14 w-100">
                درصد کل پیشرفت
              </p>
              <ProgressCircle
                percent={
                  steps && steps.length
                    ? steps.reduce((a, step) => a + step.complete_percent, 0) /
                      steps.length
                    : 0
                }
                size={100}
                fontSize={16}
              />
            </div>
          </Card>
        </Container>
        <Modal
          isOpen={MonitorModal}
          contentLabel="Monitor Modal"
          portalClassName="full_screen_modal"
        >
          <ModalPartners
            partners={
              steps && steps.length
                ? steps[modalPartnerNum].partners
                  ? [
                      ...steps[modalPartnerNum].partners,
                      this.state.referrer_person,
                    ]
                  : [this.state.referrer_person]
                : []
            }
            onClose={this.handleCloseMasoleanjam}
            getNameById={this.getNameById}
          />
        </Modal>
        <Modal
          isOpen={MonitorModalActions}
          contentLabel="Monitor Modal"
          portalClassName="full_screen_modal"
          className="modal-actions"
        >
          <ModalActions
            actions={
              steps && steps.length ? steps[modalActionsNum].actions : []
            }
            onClose={this.handleCloseActions}
          />
        </Modal>
      </Container>
    );
  }
}

class ModalPartners extends Component {
  render() {
    const { partners, onClose, getNameById } = this.props;

    return (
      <div className="modal--show-partners">
        <div className="banner">
          <p>مسئولین</p>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <img src={standingPerson} alt="standingPerson" />
        <ul>
          {partners &&
            partners.length &&
            partners.map((id, i) => {
              const temp = getNameById(+id, false, false, true);
              if (temp === undefined) return null;

              const { fn, ln, post } = temp;

              return (
                <li key={i}>
                  <div>{`${fn} ${ln}`}</div>
                  <div>{post}</div>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}

class Card extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}

class ProgressBar2 extends Component {
  getUnitString = (value, unit) => {
    return `${value} ${unit}`;
    // return `${value} ${unit}${value > 1 ? "s" : ""}`;
  };

  formatDuration = (seconds) => {
    if (seconds === 0) return "اتمام زمان انجام کار";

    const units = [
      { unit: "سال", duration: 60 * 60 * 24 * 365 },
      { unit: "روز", duration: 60 * 60 * 24 },
      { unit: "ساعت", duration: 60 * 60 },
      // { unit: "دقیقه", duration: 60 },
      // { unit: "ثانیه", duration: 1 },
    ];

    const result = units
      .map(({ unit, duration }) => {
        const value = Math.floor(seconds / duration);
        seconds -= value * duration;
        return value > 0 ? this.getUnitString(value, unit) : null;
      })
      .filter((unitString) => unitString !== null);

    return result.length === 1 ? result[0] : result.join(" و ");
  };

  render() {
    const {
      start_atUnFormated,
      start_atUnix,
      finish_atUnFormated,
      finish_atUnix,
    } = this.props;

    const now = Math.floor(new Date().getTime() / 1000);
    const passed = now - start_atUnix;
    const total = finish_atUnix - start_atUnix;
    const remaining = total - passed;
    const percent = Math.floor((passed / total) * 100);
    const progressVal = remaining > 0 ? percent : 100;

    const tooltipVal = this.formatDuration(remaining);

    return (
      <div className="eop-visit__list__item__progress-bar">
        <Progress
          value={progressVal}
          striped
          color="success"
          className="bar"
          data-tip={tooltipVal}
        />
        <p className="dates">
          <span>{finish_atUnFormated}</span>
          <span>{start_atUnFormated}</span>
        </p>
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
      />
    );
  }
}

class TransparentInput extends Component {
  render() {
    return (
      <input
        className={`transparent-input ${this.props.className}`}
        placeholder={`${this.props.placeholder}`}
        value={this.props.value}
        onChange={this.props.onChange}
      />
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <>
        <button
          className={`btn-round ${this.props.className}`}
          onClick={this.props.onClick}
          data-tip={this.props.data_tip}
        ></button>
        <ReactTooltip type="dark" />{" "}
      </>
    );
  }
}

class List extends Component {
  render() {
    return <ul className={`${this.props.className}`}>{this.props.children}</ul>;
  }
}

class Banner2 extends Component {
  render() {
    return (
      <li className="eop-visit__list__banner" key="0">
        <div className="eop-visit__list__banner__child">ردیف</div>
        <div className="eop-visit__list__banner__child">
          شـرح فعـالیت هـای اقـدام اصلاحـی
        </div>
        <div className="eop-visit__list__banner__child">
          تاریـخ شـروع و پایـان
        </div>
        <div className="eop-visit__list__banner__child">اقدامات انجام شده</div>
        <div className="eop-visit__list__banner__child">مسئولین</div>
        <div className="eop-visit__list__banner__child">% پیشرفت</div>
      </li>
    );
  }
}

class ListItem2 extends Component {
  render() {
    const { steps, i, onMasoleanjam } = this.props;
    const {
      status,
      description,
      complete_percent,
      start_at,
      finish_at,
      partners,
    } = steps[i];

    const start_atUnFormated = formatDate(start_at);
    const start_atUnix = Math.floor(new Date(start_at).getTime() / 1000);

    const finish_atUnFormated = formatDate(finish_at);
    const finish_atUnix = Math.floor(new Date(finish_at).getTime() / 1000);

    return (
      <li className={`eop-visit__list__item ${status}`}>
        <p className="eop-visit__list__item__text">{i + 1}</p>
        <p className="eop-visit__list__item__text">
          {description.length > 25
            ? description.slice(0, 25) + "..."
            : description}
        </p>
        <ProgressBar2
          start_atUnFormated={start_atUnFormated}
          start_atUnix={start_atUnix}
          finish_atUnFormated={finish_atUnFormated}
          finish_atUnix={finish_atUnix}
        />
        <ListItemBtnContainer2>
          {/* <BtnRound
                data_tip="ویرایش"
                className="checklist-icon"
                onClick={onActions}
              /> */}
          {/* {actions && actions.length ? (
            <BtnRound
              className='checklist-icon'
              data_tip='اقدامات انجام شده'
              onClick={onActions}
            />
          ) : ( */}
          <BtnRound
            className="checklist-black-icon"
            data_tip="اقدامات انجام شده"
          />
          {/* )} */}
        </ListItemBtnContainer2>
        <ListItemBtnContainer2>
          {partners && partners.length ? (
            <BtnRound
              className="masoleanjam-icon"
              data_tip="همکاران"
              onClick={onMasoleanjam}
            />
          ) : (
            <BtnRound className="masoleanjam-black-icon" data_tip="همکاران" />
          )}
        </ListItemBtnContainer2>
        <ListItemBtnContainer2>
          <ProgressCircle percent={complete_percent} size={46} fontSize={12} />
        </ListItemBtnContainer2>
      </li>
    );
  }
}

class ListItemBtnContainer2 extends Component {
  render() {
    return (
      <div className="eop-visit__list__item__btn-container">
        {this.props.children}
      </div>
    );
  }
}

class ModalActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickedOnPaperClip: false,
      actionIndex: 0,
    };
  }

  formatToLongDate = (date) => {
    return moment(date, "YYYY-MM-DD HH:mm:ss")
      .locale("fa")
      .format("jD jMMMM jYYYY");
  };

  render() {
    const { actions, onClose } = this.props;

    return (
      <div className="modal--show-actions">
        {this.state.clickedOnPaperClip ? (
          <>
            <div className="banner">
              <p>اقدامـات انجـام شـده</p>
              <button
                className="back-btn"
                onClick={() => this.setState({ clickedOnPaperClip: false })}
              >
                &#8592;
              </button>
            </div>
            <ul>
              {actions[this.state.actionIndex].files.map((file, i) => (
                <li style={{ lineHeight: "2em", textAlign: "justify" }}>
                  <span>{`${i + 1}.`}</span>
                  <a
                    href={`${userConstants.SERVER_URL}${file.file.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.file_name}
                  </a>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <>
            <div className="banner">
              <p>اقدامـات انجـام شـده</p>
              <button className="close-btn" onClick={onClose}>
                &#10005;
              </button>
            </div>
            <ul>
              {actions.length &&
                actions.map((action, i) => (
                  <li>
                    {`${action.action_description} مورخ ${this.formatToLongDate(
                      action.submitted_at
                    )} (${action.description})`}
                    {action.files && (
                      // <BtnRound
                      //   className="attach-icon"
                      //   onClick={() =>
                      //     this.setState({
                      //       clickedOnPaperClip: true,
                      //       actionIndex: i,
                      //     })
                      //   }
                      // >
                      //   x
                      // </BtnRound>
                      // <button
                      //   onClick={() =>
                      //     this.setState({
                      //       clickedOnPaperClip: true,
                      //       actionIndex: i,
                      //     })
                      //   }
                      // >
                      //   دیدن الصاقی ها
                      // </button>
                      <BtnRound
                        className="attach-icon"
                        onClick={() =>
                          this.setState({
                            clickedOnPaperClip: true,
                            actionIndex: i,
                          })
                        }
                      >
                        دیدن الصاقی ها
                      </BtnRound>
                    )}
                  </li>
                ))}
            </ul>
          </>
        )}
        <div className="u-mg-top--mid d-flex justify-content-center mt-3  w-100 ">
          <button
            className=" btn btn-primary rounded-pill py-3 text-white font-weight-bold u-fn-14 "
            style={{ width: "200px", cursor: "pointer" }}
            onClick={() =>
              this.state.clickedOnPaperClip
                ? this.setState({ clickedOnPaperClip: false })
                : onClose()
            }
          >
            بازگشت
          </button>
        </div>
      </div>
    );
  }
}

class ProgressCircle extends Component {
  render() {
    const { percent, size, fontSize } = this.props;

    return (
      <div
        style={{
          width: `${size}px`,
          height: `${size}px`,
          position: "relative",
        }}
      >
        <CircularProgressbar
          value={percent}
          styles={buildStyles({
            display: "grid",
            placeItems: "center",
            textColor: "red",
            pathColor: "#104c82",
            trailColor: "#d4d4d4",
          })}
        />
        <p
          style={{
            fontSize: `${fontSize}px`,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {`${percent}%`}
        </p>
      </div>
    );
  }
}

const EopVisit = connect((state) => ({
  globalStorage: state.globalStorage,
}))(Eop_Visit_);

export { EopVisit };
